// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__eCvS+","dark":"Loading_dark__96w8z"};